/**
 *
 * @component 个人中心/我的方案--装修方案/我的方案tab
 *
 **/

import './MySchemeTab.scss';
import DecorationCard4B from '&/components/ProjectSpace/DecorationCard4B';
import BaseModal from '&/components/BaseModal';
import useStoreState from '&/utils/customHooks/useStoreState';
import { logoQRcodeGenerate } from '&/utils/commonForPC';
import warningIcon from '&/assets/img/userCenter/warnimg.png';
import { SearchOutlined } from '@ant-design/icons';
import {
    Pagination,
    Spin,
    Menu,
    Form,
    Input,
    DatePicker,
    Select,
    Button,
    message,
    Modal,
} from 'antd';
// import { useRouterTarget } from '&/utils/customHooks';
import { useEffect, useState } from 'react';
import { isMobile, copyText } from '&/utils/common';
import {
    getProjectList,
    // getProjecDetail,
    schemeDiscard,
    getSchemeShareUrl,
    schemeCopy,
    schemeDelete,
    schemeRename,
} from '@/api/personCenter/decorationManage';
import BuyService from '@/components/UserCenter1.4/BuyService';

const { Item } = Menu;
const GRATIS_PROJECT_NUM = 5;
export default function MySchemeTab(props) {
    const { type } = props;

    const appStore = useStoreState('appStore');

    // const reducer = (state, action) => {
    //     const MAP = {
    //         show: true,
    //         hide: false,
    //     };
    //     return MAP[action.type];
    // };

    // const targetPage = useRouterTarget();

    // const targetDetail = schemeId => {
    //     targetPage({
    //         pathname: '/user-center/decoration-scheme/decoration-design',
    //         search: {
    //             schemeId,
    //         },
    //     });
    // };

    const [projectList, setProjectList] = useState([]);
    const [page, setPage] = useState({ page: 1, totalList: 0, pageNum: 20 });
    const [loading, setLoading] = useState(false);
    const [gratisProjectNum, setGratisProjectNum] =
        useState(GRATIS_PROJECT_NUM);

    const getData = async (page, paramsSort) => {
        const api = {
            discard: schemeDiscard,
            active: getProjectList,
        };
        try {
            const { data, code, msg } = await api[type]({
                page,
                pageNum: 20,
                keyword: keyWord,
                date: range.map(v => {
                    return parseInt(v.valueOf() / 1000) + '';
                }),
                sort: paramsSort || sort,
            });
            if (code === 0) {
                setLoading(false);
                setProjectList(data.list);
                setGratisProjectNum(
                    data.gratisProjectNum || GRATIS_PROJECT_NUM
                );
                setPage(data.page);
                if (type === 'active') {
                    props.setNumber(data?.page?.totalList);
                }
            } else {
                setLoading(false);
                setProjectList([]);
                setGratisProjectNum(GRATIS_PROJECT_NUM);
                throw msg;
            }
        } catch (err) {
            setLoading(false);
            setProjectList([]);
            setGratisProjectNum(GRATIS_PROJECT_NUM);
            throw err;
        }
    };

    useEffect(() => {
        setLoading(true);
        getData(page.page);
    }, [page.page, props.searchText, props.type]);

    useEffect(() => {
        console.log('type', type);
    }, [type]);

    const handlePageChange = page => {
        setPage(state => ({ ...state, page }));
    };

    /*  const [projectDetail, setProjectDetail] = useState({
        detail: {},
        house: {},
    }); */

    /* const showPreview = async (projectVId, type) => {
        try {
            const { data } = await getProjecDetail({ projectVId, div: 2 });
            setProjectDetail(data);
        } catch (err) {
            throw err;
        }
    }; */

    const [visible, setVisible] = useState(false);
    const [formData, setFormData] = useState({});

    const onCopy = async copyStr => {
        await copyText(copyStr);
        message.success(intl.get('mySchemeTab.copySuccess'));
    };

    const [isShow, setIsShow] = useState(false); // 分享弹框
    const [inviteData, setInviteData] = useState({});

    const handleClickMenu = (e, item) => {
        setFormData({
            name: item.title,
            ...item,
            createName: appStore.userInfo.username,
            createWithInit: true,
            schemeId: item.id,
        });

        const share = () => {
            getSchemeShareUrl({ schemeId: item.id }).then(async res => {
                if (res?.code === 0 && res?.data) {
                    const url = res.data.fdgFile;
                    const code = await logoQRcodeGenerate({ url });
                    setInviteData({
                        url,
                        code,
                    });
                    setIsShow(true);
                }
            });
        };

        const copy = () => {
            schemeCopy({ schemeId: item.id }).then(({ msg }) => {
                message.success(msg);
                getData(1);
            });
        };

        const deleteScheme = () => {
            Modal.confirm({
                title: intl.get('base.warning'),
                icon: (
                    <img
                        src={warningIcon}
                        alt="warning"
                        className="confirm-icon"
                    />
                ),
                content: intl.get('mySchemeTab.confirmDelete'),
                centered: true,
                okText: intl.get('base.confirm'),
                cancelText: intl.get('base.cancel'),
                className: 'confirm-modal',
                async onOk(close) {
                    try {
                        await schemeDelete({ schemeId: item.id });
                        close();
                    } finally {
                        getData(1);
                        close();
                    }
                },
            });
        };

        const createProject = () => {
            setVisible(true);
        };

        const handler = {
            0: () => {
                onRename(item);
            },
            1: createProject,
            2: copy,
            3: share,
            4: deleteScheme,
        };

        handler[e.key]();
    };

    const menu = item => (
        <Menu onClick={e => handleClickMenu(e, item)}>
            {type === 'active' ? (
                <>
                    <Item key={0}>{intl.get('mySchemeTab.rename')}</Item>
                    <Item key={1}>{intl.get('mySchemeTab.createProject')}</Item>
                    {/* <Item key={2}>复制方案</Item> */}
                    <Item key={3}>{intl.get('mySchemeTab.share')}</Item>
                </>
            ) : null}
            <Item key={4}>{intl.get('mySchemeTab.delete')}</Item>
        </Menu>
    );

    const [keyWord, setKeyWord] = useState('');

    const keyWordItem = (
        <Form.Item label={intl.get('mySchemeTab.name')}>
            <Input
                allowClear
                prefix={
                    <i
                        className="icon-search filled"
                        style={{ fontSize: '0.75rem' }}
                    />
                }
                style={{
                    width: '10rem',
                }}
                value={keyWord}
                placeholder={intl.get('mySchemeTab.projectNamePlaceHolder')}
                onChange={e => void setKeyWord(e.target.value)}></Input>
        </Form.Item>
    );

    const [range, setRange] = useState([]);

    function onDateChange(dates) {
        dates = dates || [];
        setRange(dates);
    }

    const datePickerItem = (
        <Form.Item label={intl.get('mySchemeTab.timeRange')}>
            <DatePicker.RangePicker
                allowClear
                format="YYYY-MM-DD"
                separator="~"
                value={range}
                onChange={onDateChange}
                suffixIcon={
                    <i className="icon-calendar filled" />
                }></DatePicker.RangePicker>
        </Form.Item>
    );

    const [sort, setSort] = useState(2);
    const sortOptions = [
        {
            label: intl.get('projectSpace.sortByUpdate'),
            value: 2,
        },
        {
            label:
                type !== 'discard'
                    ? intl.get('mySchemeTab.sortByTime')
                    : intl.get('mySchemeTab.sortByShare'),
            value: 1,
        },
    ];
    const handleSort = e => {
        setSort(e);
        getData(page.page, e);
    };
    const sortSelect = (
        <Select
            className="sort-select"
            value={sort}
            options={sortOptions}
            onChange={handleSort}
            suffixIcon={<i className="icon-arrow-down outlined" />}
            bordered={false}></Select>
    );

    const handleSearch = () => {
        getData(page.page);
    };

    const [formRef] = Form.useForm();
    const [renameVisible, setRenameVisible] = useState(false);
    const [okLoading, setOkLoading] = useState(false);

    function onRename(item) {
        formRef.setFieldsValue({
            schemeId: item.id,
            title: item.title,
        });
        setRenameVisible(true);
    }

    const onCancel = () => {
        formRef.resetFields();
        setRenameVisible(false);
    };

    function onSubmitName(values) {
        setOkLoading(true);
        schemeRename({
            ...values,
        })
            .then(({ msg }) => {
                message.success(msg);
                const idx = projectList.findIndex(
                    e => e.id === values.schemeId
                );
                setProjectList(prev => {
                    const next = [...prev];
                    let item = next.splice(idx, 1)[0];
                    item.title = values.title;
                    item.updateDate = parseInt(new Date().getTime() / 1000);
                    next.unshift(item);
                    return next;
                });
                setRenameVisible(false);
            })
            .finally(() => {
                setOkLoading(false);
            });
    }

    return (
        <Spin spinning={loading}>
            <div className="params-wrap">
                <Form layout="inline">
                    {keyWordItem}
                    {datePickerItem}
                    <Form.Item>
                        <Button
                            type="primary"
                            icon={<SearchOutlined />}
                            onClick={handleSearch}>
                            {intl.get('mySchemeTab.search')}
                        </Button>
                    </Form.Item>
                </Form>
                {sortSelect}
            </div>
            <div className="my-scheme-tab">
                {isMobile() ? props.searchEl : null}

                {projectList.map((e, i) => (
                    <DecorationCard4B
                        key={i}
                        value={e}
                        go2Detail={() => {}}
                        menuRender={() => menu(e)}
                    />
                ))}

                <Pagination
                    size="small"
                    current={page.page}
                    onChange={handlePageChange}
                    pageSize={page.pageNum}
                    total={page.totalList}
                    showSizeChanger={false}
                    showTotal={total => intl.get('base.total', { total })}
                />
            </div>
            {visible && (
                <BuyService
                    visible={visible}
                    initData={formData}
                    div={2}
                    gratisProjectNum={gratisProjectNum}
                    setVisible={setVisible}
                    refesh={() => {}}
                />
            )}

            <Modal
                visible={isShow}
                footer={null}
                width={320}
                centered
                className="share-modal"
                title={intl.get('mySchemeTab.share')}
                closeIcon={<i className="icon-close filled close-icon" />}
                onCancel={() => setIsShow(false)}>
                <div className="copy-url-wrap" title={inviteData.url}>
                    <p className="url-text text-no-wrap">{inviteData.url}</p>
                    <div
                        className="pointer copy-btn"
                        onClick={() => onCopy(inviteData.url)}>
                        {intl.get('base.copy')}
                    </div>
                </div>
                <img className="share-qrcode" src={inviteData.code}></img>
                <div className="share-hint">
                    {intl.get('decorationScheme.validFor7Days')}
                </div>
            </Modal>

            <BaseModal
                title={intl.get('mySchemeTab.modifiedName')}
                visible={renameVisible}
                onOk={formRef.submit}
                width="20rem"
                forceRender
                okButtonProps={{
                    loading: okLoading,
                }}
                onCancel={onCancel}>
                <Form form={formRef} onFinish={onSubmitName}>
                    <Form.Item
                        name="title"
                        validateFirst
                        rules={[
                            {
                                required: true,
                                message: intl.get(
                                    'mySchemeTab.inputNamePrompt'
                                ),
                            },
                            {
                                validator: async (rule, value) => {
                                    if (!value) return;
                                    const val = value.replace(
                                        /[\u4e00-\u9fa5]/g,
                                        'aa'
                                    );
                                    if (val.length < 31) {
                                        return Promise.resolve();
                                    }
                                    throw new Error(
                                        intl.get('mySchemeTab.maxLength')
                                    );
                                },
                            },
                        ]}>
                        <Input allowClear></Input>
                    </Form.Item>
                    <Form.Item name="schemeId" hidden>
                        <Input></Input>
                    </Form.Item>
                </Form>
            </BaseModal>
        </Spin>
    );
}
